module.exports = __webpack_public_path__ + "static/media/3.2f88db8c.png";